import { Component, OnInit } from '@angular/core';
import { LenguageService } from '../../@core/utils/lenguage.service'

import { UserService } from "../../@core/api/users.service"

@Component({
  selector: 'ngx-invoices',
  templateUrl: './invoices.component.html',
  styleUrls: ['./invoices.component.scss']
})
export class InvoicesComponent implements OnInit {
  loading:boolean = false;
  invoices:any = [];

  constructor(
    private userService: UserService,
    public language: LenguageService,
    ) { }

  async ngOnInit() {
    this.loading = true;
    this.invoices = await this.userService.invoices();
    this.loading = false;
  }

}
